import { AxiosResponse } from 'axios';
import {
  IChangePrimaryGuardianPayload,
  IChangePrimaryGuardianResponse,
  IGuardianPayload,
  ICreateGuardianResponse,
  IGetGuardiansParams,
  IGetGuardiansResponse,
  IGetGuardianTypesResponse,
  ILinkGuardianPayload,
  ILinkGuardianResponse,
  IRemoveGuardianRelationshipPayload,
  IRemoveGuardianRelationshipResponse,
  ISendGuardianInvitationPayload,
  ISendGuardianInvitationResponse,
  IUpdateGuardianPayload,
} from '../../interface';
import api from '../api';

const getGuardians = async (
  params: IGetGuardiansParams,
): Promise<AxiosResponse<IGetGuardiansResponse>> => {
  const res: AxiosResponse<IGetGuardiansResponse> = await api.get('/guardian', { params });
  return res;
};

const changePrimaryGuardian = async (
  payload: IChangePrimaryGuardianPayload,
): Promise<AxiosResponse<IChangePrimaryGuardianResponse>> => {
  const res: AxiosResponse<IChangePrimaryGuardianResponse> = await api.post(
    '/guardian/change-primary',
    payload,
  );
  return res;
};

const createGuardian = async (
  payload: IGuardianPayload,
): Promise<AxiosResponse<ICreateGuardianResponse>> => {
  const res: AxiosResponse<ICreateGuardianResponse> = await api.post('/guardian', payload);
  return res;
};

const updateGuardian = async (
  id: string,
  payload: IUpdateGuardianPayload,
): Promise<AxiosResponse<{ message: string }>> => {
  const res: AxiosResponse<{ message: string }> = await api.patch(`/guardian/${id}`, payload);
  return res;
};

const removeGuardian = async (
  payload: IRemoveGuardianRelationshipPayload,
): Promise<AxiosResponse<IRemoveGuardianRelationshipResponse>> => {
  const res: AxiosResponse<IRemoveGuardianRelationshipResponse> = await api.delete(
    '/guardian/relationship',
    { data: payload },
  );
  return res;
};

const linkGuardianToStudent = async (
  payload: ILinkGuardianPayload,
): Promise<AxiosResponse<ILinkGuardianResponse>> => {
  const res: AxiosResponse<ILinkGuardianResponse> = await api.post(
    '/guardian/relationship',
    payload,
  );
  return res;
};

const getGuardianTypes = async (): Promise<AxiosResponse<IGetGuardianTypesResponse>> => {
  const res: AxiosResponse<IGetGuardianTypesResponse> = await api.get('/guardian/types');
  return res;
};

const deleteGuardian = async (id: string): Promise<AxiosResponse<{ message: string }>> => {
  const res: AxiosResponse<{ message: string }> = await api.delete(`/guardian/${id}`);
  return res;
};

/**
 * Send (or resend) invitation emails to the given guardians. The same endpoint
 * covers both send and resend: invoking it for an already-invited guardian
 * simply re-sends the invitation.
 */
const sendInvitation = async (
  payload: ISendGuardianInvitationPayload,
): Promise<AxiosResponse<ISendGuardianInvitationResponse>> => {
  const res: AxiosResponse<ISendGuardianInvitationResponse> = await api.post(
    '/guardian/invitation',
    payload,
  );
  return res;
};

export const guardianService = {
  getGuardians,
  changePrimaryGuardian,
  createGuardian,
  updateGuardian,
  deleteGuardian,
  removeGuardian,
  getGuardianTypes,
  linkGuardianToStudent,
  sendInvitation,
};
